module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "row-bg p-10 mt-10 bg-lightgarg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "no-match-text": "No data",
      "no-data-text": "No data",
      "filterable": "",
      "clearable": "",
      "placeholder": "Trip"
    },
    on: {
      "change": function($event) {}
    },
    model: {
      value: (_vm.selecttripvalue),
      callback: function($$v) {
        _vm.selecttripvalue = $$v
      },
      expression: "selecttripvalue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])], 1), _vm._v(" "), _c('transfer-box', {
    attrs: {
      "selecttripvalue": _vm.selecttripvalue
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a6f0bb4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/teacher/TeacherRelation.vue
// module id = 617
// module chunks = 1